import React from 'react';
import { Icon, Text } from '../';
import { Link } from 'react-router-dom';

export const MenuItem = ({ title, iconName, active, href }) => {
  return (
    <Link
      to={{ pathname: href }}
      className="flex-center-start cursor-pointer nav-link px-3 pb-3"
    >
      <Icon
        color={active ? 'white' : 'primaryText'}
        className="d-flex align-items-center ml-2"
        size={20}
        name={iconName}
      />
      <Text
        size="mlg"
        color={active ? 'white' : 'primaryText'}
        hoverColor="white"
        className="user-select-none"
      >
        {title}
      </Text>
    </Link>
  );
};
